/*********************** Custom JS for Boost AI Search & Discovery  ************************/
// if (window.boostSDAppConfig) {

//     window.boostSDAppConfig.integration =  Object.assign({
    
//     wishlists: 'growave'
    
//     }, window.boostSDAppConfig.integration || {});
    
// }

// window.addEventListener('product-list-change', function () {
//     $(".boost-sd__product-item .ssw-faveiticon").each (function () {
//         var icon = '<svg version="1.1" id="Layer_2_00000167373326528626732350000012532880281809364912_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 102.9 89.2" style="enable-background:new 0 0 102.9 89.2;" xml:space="preserve" class="header-icon header-icon-wishlist">        <style type="text/css">         .st0-icon-wishlist{fill:none;stroke:#00110E;stroke-width:3;stroke-miterlimit:10;}        </style>        <g id="Guide">         <g>           <g>           <path class="st0-icon-wishlist" d="M74.4,2.3c-6.7,0-13,2.5-17.8,7.1l-5.2,5.1l-5.2-5.1c-4.7-4.6-11.1-7.1-17.8-7.1s-13,2.5-17.7,7.1             c-5.3,5.2-8.2,12-8.2,19.3S5.4,42.8,10.7,48l39.7,38.5c0.3,0.3,0.7,0.4,1,0.4s0.8-0.1,1-0.4L92.1,48c5.3-5.1,8.2-12,8.2-19.3             s-2.9-14.2-8.2-19.3C87.5,4.8,81.2,2.3,74.4,2.3L74.4,2.3z"></path>           </g>         </g>        </g>        </svg>' 
//         $(this).children('i').html(icon);
//     });
// });

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
      componentRegistry.useComponentPlugin('ProductSwatchOption', {
        name: 'ProductSwatchOption - Custom Swatch Image Url',
        apply: (e) => ({
          props: (props) => {
            if(props.labelAs === 'image') {
                let _label = props.label;
                const id = props.id.split("-")[2]
                props.customSwatchImageUrl = (fileBaseUrl) => {
                    const invalidChars = /[/\\:*?"<>|!';@&=+$,%#[\] ]/g;
                    let customizeName = 'btsi_' + id + "_" + _label.replace(invalidChars, '-'); // do some thing to convert _label to name file
                    if (customizeName.endsWith("-")) customizeName = customizeName.slice(0, -1);
                    return `url(${fileBaseUrl}${customizeName}.jpg)`
                };
            }
  
            return props;
          },
        }),
      });
  }]);
  function isIpad() {
    return navigator.userAgent.match(/iPad/i) !== null;
}

(function ($) {
    window.addEventListener('product-list-change', function () {
    console.log('this, product-list-change');
      document.querySelectorAll('.boost-sd__view-as span').forEach( viewas =>{
         if (window.innerWidth < 1024 && window.innerWidth > 768) {
            if(viewas.classList.contains('boost-sd__view-as-icon--grid--3')){
              $(viewas).trigger("click");
            }
         }
        else if ((window.innerWidth < 1440 && window.innerWidth > 1024) || isIpad()){
          if(viewas.classList.contains('boost-sd__view-as-icon--grid--4')){
              $(viewas).trigger("click");
            }
        }
      })
    });
  })(jQuery);

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([(componentRegistry)=>{
componentRegistry.useComponentPlugin('ProductPrice', {
      name: 'Update product price current variants',
      apply: () => ({
        props: (props,element) => {
          const productData =  element.getParentElm().getParams().props.data;
          if(productData){
          	const targetVariantId = productData.variant_id; // Replace this with the desired variant_id

              // Find the variant with the specified variant_id
              const targetVariant = productData.variants.find(variant => variant.id === targetVariantId);

              if (targetVariant) {
                const variantPrice = targetVariant.price;
                props.data.price_min = variantPrice;
              }
          }
                
          return props;
        },
      }),
    });
}]);

// window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([(componentRegistry)=>{
// componentRegistry.useComponentPlugin('ViewAs', {
//       name: 'Update product grid in tab',
//       apply: () => ({
//         props: (props) => {
//          console.log("hiht", props);
//                 props.currentCol = "grid--3"
//                 props.defaultCol = "grid--3"
//                 props.helpersRef ("grid--3")

//           return props;
//         },
//       }),
//     });
// }]);